import React from 'react'
import { Trans, useTranslation } from "react-i18next";
import {useLocalStorage} from "react-use";


const useTranslate = () => {

  const {t, i18n} =  useTranslation()


  const [activeLanguage, setActiveLanguage] = useLocalStorage("buildhub:lang", "en")

  const translateKey = (key: string, variables?: {[key:string]: string}) => t(key, {...variables});

  const TranslateText: React.FC<{
    children:string,
    i18nKey: string,
    variables?: any
  }> = ({children,i18nKey, variables}) => {
    return (<Trans i18nKey={i18nKey} values={variables}>{children}</Trans>)
  }

  const changeLanguage = async (lang: string) => {
    await i18n.changeLanguage(lang);
    setActiveLanguage(lang);

  }

  return {TranslateText, translateKey, changeLanguage, activeLanguage}

}

export default useTranslate
